/**
 * @generated SignedSource<<09d7292d58e03e4a7c766b5dd14a8771>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Contact_viewer$data = {
  readonly user: {
    readonly address: {
      readonly state: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "Contact_viewer";
};
export type Contact_viewer$key = {
  readonly " $data"?: Contact_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Contact_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Contact_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "state",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ea5bd7e64c91e7e30829b8ab011fc16f";

export default node;
